import React from 'react';
import './Review.css';
import '../Common/Footer/Footer.js';
import {xpressApi, GENERATE_BARCODE_DATA, GET_DONOR_PASS_BARCODE, EMAIL_DONOR_PASS} from '../../providers/xpress_api';
import {DotLoader} from 'react-spinners';
import DOMPurify from "dompurify";
import Header from "../Common/Header/Header";
import Footer from "../Common/Footer/Footer";
import XpressDialog from "../XpressDialog/XpressDialog";
import {getNextQuestionId} from "../../common/common";
import {PATH_DONOR_PASS, PATH_QUESTION, XPRESS_STATE_DONOR_PASS} from "../../App";

export default class Review extends React.Component
{
    constructor(props)
    {
        super(props);

        this.warmupLambdaFunctions();
        this.language = this.props.xpressState.language;
        this.translationConstants = this.props.xpressState.translationConstants;
        this.questionnaire = this.props.xpressState.questionnaire;
        this.bloodCenterProperties = this.props.xpressState.bloodCenterProperties;
        this.bloodCenterId = this.questionnaire.bloodCenterId;
        this.translationId = this.questionnaire.translation;
        this.firstTimeDonor = this.props.xpressState.ftd;
        this.dateOfBirth = this.props.xpressState.dob;
        this.sex = this.props.xpressState.sex;
        this.sexDescription = this.props.xpressState.sexDescription;
        this.questionnaireData = this.props.xpressState.questionnaireData.questions;
        this.originalQuestionIdList = this.props.xpressState.originalQuestionIdList;
        this.questionnaireNodeList = this.props.xpressState.questionnaireNodeList;
        this.responseBranchOptions = this.props.xpressState.responseBranchOptions;
        this.responses = this.props.xpressState.responses;
        this.generateBarcodeClicked = false;
        this.barcodeResponseString = null;

        this.state = {
            loading: true,
            generateBarcodeClicked: this.generateBarcodeClicked
        };

        this.handleGenerateBarcode = this.handleGenerateBarcode.bind(this);
    }

    componentDidMount() {
        let reviewData = this.getReviewData();
        this.barcodeResponseString = reviewData.barcodeResponseString;

        this.warmupInterval = setInterval(() => this.warmupLambdaFunctions(), 240000);
        this.setState({
            reviewQuestions: reviewData.reviewQuestions,
            loading: false
        });
    }

    warmupLambdaFunctions = () => {
        xpressApi.post(EMAIL_DONOR_PASS, { noOp: true }).then();
    }

    getReviewData = () => {
        let questionnaireNodeList = this.questionnaireNodeList;
        let originalQuestionIdList = this.originalQuestionIdList;

        let reviewQuestions = [];
        let barcodeResponseString = "";

        // Build the reviewQuestions array with objects containing the questions specific to the responses provided (excludes inapplicable branch, free-text and signature questions)
        let questionId = questionnaireNodeList[0].data.deQuestionId;
        do {
            let response = this.responses.find(question => parseInt(question.questionId) === questionId).response;
            reviewQuestions.push({questionId: questionId.toString(), response: response});
            questionId = getNextQuestionId(questionId, response, questionnaireNodeList, this.responseBranchOptions, this.responses);
        } while (questionId != null);

        // Generate the barcode response string based on all questions in the original questionnaire (includes inapplicable branch, free-text and signature questions) and the provided responses
        originalQuestionIdList.forEach(questionId => {
            let barcodeResponse;

            let question = this.responses.find(response => parseInt(response.questionId) === questionId);
            if (question && question.response) {
                barcodeResponse = question.response;
            }
            else {
                // No response was provided or the question type was not applicable, so insert a "0" placeholder response for the question
                barcodeResponse = "0";
            }

            barcodeResponseString += barcodeResponse;
        });

        return {reviewQuestions: reviewQuestions, barcodeResponseString: barcodeResponseString};
    }

    handleReviewClick = event =>
    {
        //
        // since the DOM can be of variable format (since we used DOMPurify to handle embedded HTML), we need to find the parent node with the Id value before we compare.
        //
        let id = "";
        let currentNode = event.target;

        while (id === "")
        {
            id = currentNode.id;
            if (id === "")
            {
                currentNode = currentNode.parentNode;
            }
        }

        this.props.history.push({
            pathname: PATH_QUESTION.replace(':bcId', this.bloodCenterId).replace(':qId', id),
            state: {
                review: true
            }
        });
    }

    handleAlert = () => {
        this.setState({generateBarcodeClicked: true});
    }

    handleGenerateBarcode = async () =>
    {
        this.setState({
            loading: true
        });

        let ftd = '';

        if (this.firstTimeDonor === true)
        {
            ftd = '1';
        } else
        {
            ftd = '0';
        }

        let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let timeZoneCode = this.getTimeZoneCode(timeZone);

        let date = new Date();
        let minutes = String(date.getMinutes());
        let hour = String(date.getHours());
        let year = String(date.getFullYear());
        let month = String(date.getMonth() + 1); // beware: January = 0; February = 1, etc.
        let day = String(date.getDate());

        if (month.length < 2)
        {
            month = '0' + month;
        }

        if (day.length < 2)
        {
            day = '0' + day;
        }

        if (hour.length < 2)
        {
            hour = '0' + hour;
        }

        if (minutes.length < 2)
        {
            minutes = '0' + minutes;
        }

        let yearString = String(year).substring(2, 4);

        let MMddyyHHmm = month + day + yearString + hour + minutes;

        let tomorrow = new Date();
        tomorrow.setDate(date.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        let expDate = tomorrow.getTime();

        let unencodedBarcodeData =
        {
            leadingZero: '0',
            sex: this.sex, // Modified to sent the sex code rather than the translated integer (HD #10194)
            sexDescription: this.sexDescription, // Added the sex description (HD #10194)
            bloodCenterId: '0' + String(this.bloodCenterId),
            donorBirthDate: this.dateOfBirth,
            firstTimeDonor: ftd,
            deQuestionnaireIdString: this.questionnaire.deQuestionnaireId,
            publishedQuestionnaireIdString: this.questionnaire.publishedQuestionnaireId,
            dateAsString: MMddyyHHmm,
            serverTimeZone: "",
            userTimeZone: timeZoneCode,
            userTime: expDate,  //time for barcode to expire
            responseCombinations: [],
            barcodeResponseString: this.barcodeResponseString
        }

        let generateBarcodeDataResponse = await xpressApi.post(GENERATE_BARCODE_DATA, unencodedBarcodeData);
        await this.getDonorPass(generateBarcodeDataResponse.data);
    }

    getTimeZoneCode(timeZone)
    {
        let timeZoneCode;

        if (timeZone === 'America/New_York')
        {
            timeZoneCode = '1';
        } else if (timeZone === 'America/Indiana/Indianapolis')
        {
            timeZoneCode = '1';
        } else if (timeZone === 'America/Indiana/Marengo')
        {
            timeZoneCode = '1';
        } else if (timeZone === 'America/Indiana/Petersburg')
        {
            timeZoneCode = '1';
        } else if (timeZone === 'America/Indiana/Vevay')
        {
            timeZoneCode = '1';
        } else if (timeZone === 'America/Indiana/Vincennes')
        {
            timeZoneCode = '1';
        } else if (timeZone === 'America/Indiana/Winamac')
        {
            timeZoneCode = '1';
        } else if (timeZone === 'America/Kentucky/Louisville')
        {
            timeZoneCode = '1';
        } else if (timeZone === 'America/Kentucky/Monticello')
        {
            timeZoneCode = '1';
        } else if (timeZone === 'America/Detroit')
        {
            timeZoneCode = '1';
        } else if (timeZone === 'America/North_Dakota/Beulah')
        {
            timeZoneCode = '2';
        } else if (timeZone === 'America/North_Dakota/Center')
        {
            timeZoneCode = '2';
        } else if (timeZone === 'America/North_Dakota/New_Salem')
        {
            timeZoneCode = '2';
        } else if (timeZone === 'America/Mexico_City')
        {
            timeZoneCode = '2';
        } else if (timeZone === 'America/Indiana/Knox')
        {
            timeZoneCode = '2';
        } else if (timeZone === 'America/Indiana/Tell_City')
        {
            timeZoneCode = '2';
        } else if (timeZone === 'America/Menominee')
        {
            timeZoneCode = '2';
        } else if (timeZone === 'America/Chicago')
        {
            timeZoneCode = '2';
        } else if (timeZone === 'America/Denver')
        {
            timeZoneCode = '3';
        } else if (timeZone === 'America/Boise')
        {
            timeZoneCode = '3';
        } else if (timeZone === 'America/Phoenix')
        {
            timeZoneCode = '3';
        } else if (timeZone === 'America/Los_Angeles')
        {
            timeZoneCode = '4';
        } else
        {
            timeZoneCode = '5';
        }

        return timeZoneCode;
    }

    getDonorPass = async (barcodeData) =>
    {
        barcodeData.stage = process.env.REACT_APP_DEPLOY_ENV;
        barcodeData.barcodeType = this.bloodCenterProperties.barcodeType;
        // Language added to barcode data to correctly translate text (QA-227)
        barcodeData.translationId = this.language;
        // console.log("bloodCenter barcode type='" + barcodeData.barcodeType + "'");

        let donorPassResponse = await xpressApi.post(GET_DONOR_PASS_BARCODE, barcodeData);

         this.setState({
             loading: false
         });

        if(donorPassResponse) {
            this.updateXpressStateValue(XPRESS_STATE_DONOR_PASS, donorPassResponse.data);

            this.props.history.push({
                pathname: (PATH_DONOR_PASS.replace(':bcId', this.bloodCenterId)),
            });
        }
    }

    updateXpressStateValue = (key, value) => {
        this.props.fnUpdateXpressStateValue(key, value);
    }

    render()
    {
        let items = [];
        let count = 1;
        let questionText;
        let responseText = "";
        let generateBarcodeModal;
        let reviewPageQuestion = this.translationConstants.reviewPageQuestion;
        let reviewPageResponse = this.translationConstants.reviewPageResponse;
        let reviewPageDonorPass = this.translationConstants.reviewPageDonorPass;

        if(this.state.reviewQuestions) {
            this.state.reviewQuestions.forEach((reviewQuestion) => {
                let question = this.questionnaireData.find(question => question.questionId === reviewQuestion.questionId)
                questionText = question.questionText;

                if (question.questionType === 'IN') {
                    responseText = 'Informational';
                }
                else if (question.questionType === 'ES') {
                    responseText = 'Signature';
                }
                else if (question.questionType === 'FT') {
                    responseText = 'Free-form Text';
                }
                else if (question.response !== 0) {
                    let questionOptions;
                    let questionOptionTextCsv = question.questionOptionText;
                    if (questionOptionTextCsv !== undefined) {
                        questionOptions = questionOptionTextCsv.split(",");
                    }
                    responseText = questionOptions[reviewQuestion.response - 1];
                }

                // Adding Spanish translations (QA-229)
                if (this.language === "2") {
                    if (question.questionType === 'IN') {
                        responseText = 'Informacional';
                    }
                    else if (question.questionType === 'ES') {
                        responseText = 'Firma';
                    }
                    else if (question.questionType === 'FT') {
                        responseText = 'Texto de Forma Libre';
                    }
                }

                if (this.state.generateBarcodeClicked) {
                    generateBarcodeModal =
                        <XpressDialog contentText={this.translationConstants.xpressDialogNavToBarcodeText}
                                      type="generateBarcode"
                                      title={this.translationConstants.xpressDialogNavToBarcodeTitle}
                                      firstButton={this.translationConstants.xpressDialogNavToBarcodeOk}
                                      secondButton={this.translationConstants.xpressDialogNavToBarcodeCancel}
                                      generateBarcode={this.handleGenerateBarcode}
                                      open={this.state.generateBarcodeClicked}/>;
                }
                else {
                    generateBarcodeModal = "";
                }

                items.push(
                    <tr id={question.questionId} onClick={this.handleReviewClick} key={count}>
                        <td>
                            {question.userSequenceCode}
                        </td>
                        <td style={{minHeight: '47.5px'}}
                            dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(questionText)}}/>
                        <td>
                            {responseText}
                        </td>
                    </tr>
                );

                count = count + 1;
            }, this);
        }

        if (this.state.loading) {
            return (
                <div className="pageWrapper">
                    <div className="contentWrapper">
                        <Header logoPath={this.questionnaire.logoPath} taglinePath={this.questionnaire.taglinePath}/>
                        <DotLoader css={"display: block; margin-top: 23vh; margin-left: auto; margin-right: auto;"} sizeUnit={"px"} size={100} color={'red'} loading={true}/>
                    </div>
                    <Footer text={this.translationConstants.xpressPoweredBy}/>
                </div>
            );
        }
        else {
            return (
                <div className="pageWrapper">
                    <div className="contentWrapper">
                        <Header logoPath={this.questionnaire.logoPath} taglinePath={this.questionnaire.taglinePath}/>
                        {generateBarcodeModal}
                        <div className="container">
                            <div className="row" style={{paddingBottom: '1em'}}>
                                <div className="col-md-12" style={{fontSize: '18px', fontWeight: 'bold'}}>{this.translationConstants.reviewPageReviewResponses}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div>
                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>{reviewPageQuestion}</th>
                                                    <th>{reviewPageResponse}</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{cursor: 'pointer'}}>{items}</tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <button type="button" className="btn btn-lg btn-success" onClick={this.handleAlert}>{reviewPageDonorPass}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer text={this.translationConstants.xpressPoweredBy}/>
                </div>
            )
        }
    }
}